import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal'; // modal弹框模块
import { Subject } from 'rxjs';

// import axios from 'axios';

/**
 * 公共服务
 * 包括内容：http请求模块、数据缓存模块
 */
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public domain = 'http://test.xiaokatouxiang.cn/index.php/KunPeng/';
  public menuVersion = '20210101';
  public iconFont = '//at.alicdn.com/t/font_2341004_xc1bbwksef.js';
  // 数据源 next(发射数据)
  private parentToChildSource = new Subject<string>();
  private childToParentSource = new Subject<string>();

  // 数据流 subscribe(取得数据)，在组件中需要订阅
  public parentToChild$ = this.parentToChildSource.asObservable();
  public childToParent$ = this.childToParentSource.asObservable();
  private tempData: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private Message: NzMessageService,
    private modalService: NzModalService,
    private injector: Injector,
  ) {}

  /**
   * 格式化日期
   */
  public date(time: any, type: string = 'Y-m-d H:i:s', isNull: boolean = false): string {
    console.log(time);
    if (time == null && isNull) {
      return '';
    }
    let myDate: any;
    time ? (myDate = new Date(time)) : (myDate = new Date());
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1 > 9 ? myDate.getMonth() + 1 : '0' + (myDate.getMonth() + 1);
    const day = myDate.getDate() > 9 ? myDate.getDate() : '0' + myDate.getDate();
    const hours = myDate.getHours() > 9 ? myDate.getHours() : '0' + myDate.getHours();
    const minutes = myDate.getMinutes() > 9 ? myDate.getMinutes() : '0' + myDate.getMinutes();
    const seconds = myDate.getSeconds() > 9 ? myDate.getSeconds() : '0' + myDate.getSeconds();
    let response: string = type;
    response = response.replace(/Y/g, year);
    response = response.replace(/m/g, month);
    response = response.replace(/d/g, day);
    response = response.replace(/H/g, hours);
    response = response.replace(/i/g, minutes);
    response = response.replace(/s/g, seconds);
    return response;
  }

  public getTime(time: any): any {
    return Math.floor(new Date(time).getTime() / 1000);
  }

  /**
   * 根据时间获取当天0点的时间戳
   * @param time
   */
  public getOrigin(time: any): any {
    const date = this.date(time, 'Y-m-d');
    const newTime = new Date(date + ' 00:00:00');
    console.log(newTime);
    return Math.floor(new Date(newTime).getTime() / 1000);
  }

  // 设置本地缓存
  public setCache(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  // 读取本地缓存
  public getCache(key: string): any {
    return JSON.parse(localStorage.getItem(key));
  }

  // 移除本地缓存
  public removeCache(key: string): void {
    localStorage.removeItem(key);
  }

  // /**
  //  * 向其他非子级模块发送消息
  //  */
  public toChild(parentDataItem: string): void {
    this.parentToChildSource.next(parentDataItem);
  }

  /**
   * 向其他非父级模块发送消息
   * @param childDataItem  消息内容
   */
  public toParent(childDataItem: object | any[]): void {
    this.childToParentSource.next(JSON.stringify(childDataItem));
  }

  public loading(show: boolean = true): void {
    this.toParent({ type: 'loading', status: show });
  }

  public get msg(): NzMessageService {
    return this.injector.get(NzMessageService);
  }

  public ajax(arg: any): Promise<unknown> {
    const type = arg.type ? arg.type : 'get';
    const url = arg.url ? arg.url : '';
    const body = arg.body ? arg.body : {};
    const params = arg.params ? arg.params : arg.data ? arg.data : {};
    const success = arg.success ? arg.success : () => {};
    const fail = arg.fail ? arg.fail : () => {};
    const complete = arg.complete ? arg.complete : () => {};
    const loading = arg.loading ? arg.loading : false;
    const options = arg.options ? arg.options : {};
    if (loading) {
      this.loading(true);
    }
    const whiteList = [
      'admin/login',
      'admin/captcha',
      'api/logout',
      'admin/sendSms?_allow_anonymous=true',
      'admin/checkMobile?_allow_anonymous=true',
      'admin/changePassword?_allow_anonymous=true',
      'admin/loginMobile?_allow_anonymous=true',
      'admin/getWinxinQrcodeUrl?_allow_anonymous=true',
      'admin/oauth?_allow_anonymous=true',
      'admin/bindUser?_allow_anonymous=true',
      'system/tool/getViewRecord',
      'system/tool/editRecord',
    ];
    if (whiteList.indexOf(url) > -1) {
    } else {
      //  校验更新信息
      this.http.get('system/tool/getViewRecord', {}).subscribe((res) => {
        if (res['type']) {
          this.toParent({ event: 'update', type: true });
        }
      });
    }
    if (type === 'post') {
      return new Promise((resolve, reject) => {
        this.http.post(url, params, options).subscribe(
          (res) => {
            if (res['code'] == undefined) {
              success(res);
              resolve(res);
            } else {
              resolve(res);
            }

            if (loading) {
              this.loading(false);
            }
          },
          (res) => {
            fail(res);
            reject(res);
            if (loading) {
              this.loading(false);
            }
          },
          () => {
            complete();
          },
        );
      });
    } else {
      return new Promise((resolve, reject) => {
        options['params'] = params;
        this.http.get(url, options).subscribe(
          (res) => {
            if (res['code'] == undefined || res['code'] == 0) {
              success(res);
              resolve(res);
            } else {
              fail(res);
              // reject(res);
            }
            if (loading) {
              this.loading(false);
            }
          },
          (res) => {
            fail(res);
            reject(res);
            if (loading) {
              this.loading(false);
            }
          },
          () => complete(),
        );
      });
    }
  }

  /**
   * 上传图片
   * @param params
   */
  async uploadFile(params: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.ajax({
        url: 'upload/up_file',
        data: params,
        type: 'post',
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  imgHeadError(e: any, type: any): void {
    if (type == 2) {
      e.target.src = './assets/man.png';
    } else {
      e.target.src = './assets/woman.png';
    }
  }
}
